import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Button, Form } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";

const UpdateFamilyAssets = () => {
  const history = useHistory();
  const { id } = useParams();

  const assetsList = [
    "Two wheeler",
    "Car",
    "Agri Land",
    "House land",
    "Travels",
    "Transport",
    "Rental vehicle",
    "Own shop",
    "Own business",
    "Own company",
    "Rental shops",
    "Rental houses",
    "Small business",
    "Stock market investments",
    "Pension",
    "Residential plots",
    "Government agency",
  ];

  const [selectedAssets, setSelectedAssets] = useState([]);

  const isAssetSelected = (asset) => {
    return selectedAssets.some(
      (selected) => selected.toLowerCase().trim() === asset.toLowerCase().trim()
    );
  };

  const handleAssetToggle = (asset) => {
    if (isAssetSelected(asset)) {
      setSelectedAssets(selectedAssets.filter(
        (a) => a.toLowerCase().trim() !== asset.toLowerCase().trim()
      ));
    } else {
      setSelectedAssets([...selectedAssets, asset]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: Number(id),
      familyAssets: selectedAssets.join(", "),
    };

    api
      .post("/admin/userProfile/assetUpdate/", payload)
      .then(() => {
        Swal.fire("Success", "Family assets updated", "success").then(() => {
          history.goBack();
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to update family assets", "error");
      });
  };

  useEffect(() => {
    api
      .get(`/admin/userProfile/profileView?userId=${id}`)
      .then((res) => {
        const d = res.data && res.data.data ? res.data.data : {};
        const family = d.userFamily || {};
        if (family.familyAssets) {
          const assets = family.familyAssets.split(/,\s*/).map((a) => a.trim()).filter(a => a);
          setSelectedAssets(assets);
        }
      })
      .catch(() => {
        Swal.fire("Error", "Failed to load family assets", "error");
      });
  }, [id]);

  const chipStyle = (isSelected) => ({
    display: "inline-block",
    padding: "10px 20px",
    margin: "8px",
    borderRadius: "25px",
    border: isSelected ? "none" : "1.5px solid #757575",
    backgroundColor: isSelected ? "#000" : "#fff",
    color: isSelected ? "#fff" : "#333",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
    transition: "all 0.2s ease",
    userSelect: "none",
  });

  return (
    <div style={{ background: "#fff", marginTop: "70px" }}>
      <div
        style={{
          color: "#1a237e",
          fontWeight: "900",
          padding: "20px 10px",
        }}
      >
        <h4 style={{ fontSize: "1.8rem" }}>Update Family Assets</h4>
      </div>

      <Form
        onSubmit={handleSubmit}
        style={{ padding: 24, maxWidth: 1200, margin: "0 10px" }}
      >
        <div style={{ marginBottom: "20px" }}>
          <p style={{ color: "#212121", fontWeight: "800", marginBottom: "15px" }}>
            Select Family Assets
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
            {assetsList.map((asset, index) => (
              <div
                key={index}
                style={chipStyle(isAssetSelected(asset))}
                onClick={() => handleAssetToggle(asset)}
              >
                {asset}
              </div>
            ))}
          </div>
        </div>

        {selectedAssets.length > 0 && (
          <div style={{ 
            marginTop: "20px", 
            padding: "15px", 
            backgroundColor: "#f5f5f5", 
            borderRadius: "12px",
            border: "1.5px solid #757575"
          }}>
            <p style={{ fontWeight: "800", marginBottom: "10px", color: "#212121" }}>Selected Assets:</p>
            <p style={{ color: "#333", fontWeight: "bold" }}>{selectedAssets.join(", ")}</p>
          </div>
        )}

        <Button
          type="submit"
          style={{
            width: "30%",
            borderRadius: 8,
            backgroundColor: "#000",
            color: "#fff",
            fontWeight: "bold",
            padding: "10px 0",
            marginTop: "30px",
          }}
        >
          Save & Continue
        </Button>
      </Form>
    </div>
  );
};

export default UpdateFamilyAssets;
